export default __webpack_public_path__ + "static/media/toy15.e56c469c.jfif";